var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconMenuEmpty = function SvgIconMenuEmpty(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40.005,
    viewBox: "0 0 40 40.005",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#8798ad;}.a{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.995 -0.995)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.933,4.8a3.461,3.461,0,1,0-3.041,3.1,15,15,0,0,0,.1,17.843,2.8,2.8,0,0,0,4.23.2L26.192,8.971a2.8,2.8,0,0,0-.2-4.23A15,15,0,0,0,7.933,4.8ZM5.522,3.423a1.461,1.461,0,1,1-2.067,0A1.461,1.461,0,0,1,5.522,3.423ZM7.808,7.556A13,13,0,0,0,6.593,24.539a.8.8,0,0,0,1.215-.012L24.778,7.556a.8.8,0,0,0,.012-1.215A13,13,0,0,0,7.808,7.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4,35a3,3,0,1,0,0,6H38a3,3,0,0,0,0-6Zm34,2H4a1,1,0,0,0,0,2H38a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-3480.5-16419a3.005,3.005,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-3480.5-16419Zm2,0a1,1,0,0,0,1,1,1,1,0,0,0,1-1,1,1,0,0,0-1-1A1,1,0,0,0-3478.5-16419Zm-23-2a1,1,0,0,1,1-1,1,1,0,0,1,1,1,1,1,0,0,1-1,1A1,1,0,0,1-3501.5-16421Zm6-3a3.005,3.005,0,0,1,3-3,3,3,0,0,1,2.995,3,3,3,0,0,1-2.995,3A3,3,0,0,1-3495.5-16424Zm2,0a1,1,0,0,0,1,1,1,1,0,0,0,1-1,1,1,0,0,0-1-1A1,1,0,0,0-3493.5-16424Zm9-3a1,1,0,0,1,1-1,1,1,0,0,1,1,1,1,1,0,0,1-1,1A1,1,0,0,1-3484.5-16427Zm8-6a1,1,0,0,1,1-1,1,1,0,0,1,1,1,1,1,0,0,1-1,1A1,1,0,0,1-3476.506-16433Zm-9-3a1,1,0,0,1,1-1,1,1,0,0,1,1,1,1,1,0,0,1-1,1A1,1,0,0,1-3485.507-16436Z",
    transform: "translate(3509 16453)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconMenuEmpty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-menu-empty.182331bf.svg";
export { ForwardRef as ReactComponent };